module.exports = __webpack_public_path__ + "img/lamer_logo_footer.36f0c4f9.png";